import store from "@/store";

export const fullName = ({ name, surname, patronymic }) => {
  return [surname, name, patronymic]
    .filter(item => typeof item === "string" && item.length > 0)
    .join(" ");
};

export const fullNameWithUnion = ({
  name,
  surname,
  patronymic,
  union_member_data: unionMemberData
}) => {
  let fName = fullName({ name, surname, patronymic });
  if (unionMemberData === null) return fName;

  let { union_id: unionId } = unionMemberData;
  let union = store.getters["unions/unions"].find(
    ({ id }) => Number(id) === Number(unionId)
  );
  if (union === undefined) return fName;

  return `${fName} (${union.name})`;
};

export const fullNameWithUnionAndBirthday = ({
  name,
  surname,
  patronymic,
  union_member_data,
  birthday
}) => {
  let fNameWithUnion = fullNameWithUnion({
    name,
    surname,
    patronymic,
    union_member_data
  });
  if (birthday === null) return fNameWithUnion;
  return `${fNameWithUnion} (${humanizeDate(birthday)})`;
};

export const surnameWithInitials = ({ name, surname, patronymic }) => {
  let resultStr = "";
  if (typeof surname === "string" && surname.length > 0) resultStr += surname;
  if (typeof name === "string" && name.length > 0)
    resultStr += ` ${name[0].toUpperCase()}.`;
  if (typeof patronymic === "string" && patronymic.length > 0)
    resultStr += ` ${patronymic[0].toUpperCase()}.`;
  return resultStr;
};

export const dictionaryConvert = (value, dictionary) =>
  value in dictionary ? dictionary[value] : value;

export const humanizeDate = date =>
  date
    .split("-")
    .reverse()
    .join(".");

export const humanizeDateTime = dateTime => {
  let [date, time] = dateTime.split(" ");
  return [humanizeDate(date), time].join(" ");
};

export const getGoogleContactObject = ({
  name,
  surname,
  patronymic,
  birthday,
  sex,
  union_member_data,
  email,
  phones
}) => {
  let obj = {
    Name: fullName({ name, surname, patronymic }),
    "Given Name": name,
    "Additional Name": surname,
    "Family Name": patronymic,
    Birthday: birthday,
    Gender: Number(sex) ? "Male" : "Female",
    "Group Membership": [
      union_member_data !== null
        ? store.getters["unions/unions"].find(
            ({ id }) => Number(id) === Number(union_member_data.union_id)
          ).name
        : "Нет",
      union_member_data !== null &&
      union_member_data.professional_group_id !== null
        ? store.getters["professionalGroups/professionalGroups"].find(
            ({ id }) =>
              Number(id) === Number(union_member_data.professional_group_id)
          ).name
        : "Нет",
      "* myContacts"
    ].join(" ::: "),
    "E-mail 1 - Type": email !== null ? "* Home" : "",
    "E-mail 1 - Value": email !== null ? email : ""
  };

  for (let i = 0; i < phones.length; i++) {
    obj[`Phone ${i + 1} - Type`] = "Mobile";
    obj[`Phone ${i + 1} - Value`] = phones[i].phone_number;
  }

  return obj;
};
